import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faStarHalf } from "@fortawesome/pro-solid-svg-icons";

const Card = (props) => {
  const {
    data: {
      image: { imgUrl, link, title: imgTitle },
      body: { category, title, titleLink, text, jumbotron },
      footer: { stars },
    },
    settings: { renderCategory, renderCurator },
  } = props;

  // TODO fix
  console.log('unused var', imgUrl, title, link, imgTitle, titleLink);

  const renderStars = () => {
    return (
      <div>
        {Array(stars.count)
          .fill(0)
          .map((_, i) => (
            <FontAwesomeIcon key={i} icon={faStar} />
          ))}
        {stars.hasHalfStar && <FontAwesomeIcon icon={faStarHalf} />}
      </div>
    );
  };

  return (
    <div className="learner-home-card">
      <div className="learner-home-card__wrapper">
        <div
          className="learner-home-card__image"
          style={{
            backgroundImage: `url('${"https://miro.medium.com/max/1200/1*mk1-6aYaf_Bes1E3Imhc0A.jpeg"}')`,
          }}
        ></div>
        <div className="learner-home-card__body">
          {renderCurator && (
            <div className="learner-home-card__body-curator">
              <img
                src="https://miro.medium.com/max/1200/1*mk1-6aYaf_Bes1E3Imhc0A.jpeg"
                alt="avatar"
              />
              <span>{jumbotron.text}</span>
            </div>
          )}
          {renderCategory && <span className="muted">{category}</span>}
          <p className="title">{title}</p>
          <span className="muted">{text}</span>
        </div>
      </div>
      <div className="learner-home-card__footer">
        <div></div>
        <div className="learner-home-card__footer-stars">
          {stars && renderStars()}
        </div>
      </div>
    </div>
  );
};

export default Card;



// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/learner-home-widget-block/components/Card.js